import zoomAppModules from './zoomApp.module'
import presentationModules from './presentation/index'
import liveStats from './live-stats.module'
import featureToggles from './feature-toggles.module'

export default {
  zoomApp: zoomAppModules,
  ...presentationModules,
  liveStats,
  featureToggles,
}
